/**
 * TX1 — rutas y labels del módulo Tesorería (solo UI).
 * Los enums/API del backend no cambian.
 */

export type TreasuryViewId =
  | 'position'
  | 'move'
  | 'transfers'
  | 'approvals'
  | 'banks'
  | 'supervision'
  | 'cash-registers'
  | 'config';

export const TREASURY_VIEWS: {
  id: TreasuryViewId;
  path: string;
  label: string;
  /** Acción mínima en módulo `cash` para ver este ítem en el menú */
  menuAction: 'read' | 'write';
}[] = [
  { id: 'position', path: '/treasury/position', label: 'Posición de tesorería', menuAction: 'write' },
  { id: 'move', path: '/treasury/move', label: 'Mover fondos', menuAction: 'write' },
  { id: 'transfers', path: '/treasury/transfers', label: 'Movimientos de fondos', menuAction: 'write' },
  { id: 'approvals', path: '/treasury/approvals', label: 'Aprobaciones', menuAction: 'write' },
  { id: 'banks', path: '/treasury/banks', label: 'Bancos', menuAction: 'write' },
  { id: 'supervision', path: '/treasury/supervision', label: 'Supervisión', menuAction: 'write' },
  { id: 'cash-registers', path: '/treasury/cash-registers', label: 'Cajas', menuAction: 'write' },
  { id: 'config', path: '/treasury/config', label: 'Configuración', menuAction: 'write' },
];

export const TREASURY_LEGACY_REDIRECTS: Record<string, string> = {
  '/treasury': '/treasury/position',
};

export function breadcrumbsForTreasuryPath(pathname: string): { label: string; to?: string }[] {
  const crumbs: { label: string; to?: string }[] = [{ label: 'Tesorería', to: '/treasury/position' }];
  const view = TREASURY_VIEWS.find((v) => pathname === v.path || pathname.startsWith(`${v.path}/`));
  if (view) {
    crumbs.push({ label: view.label });
  } else if (pathname.startsWith('/cash')) {
    crumbs.push({ label: 'Mi caja' });
  }
  return crumbs;
}

export function treasuryViewFromPath(pathname: string): TreasuryViewId {
  const hit = TREASURY_VIEWS.find((v) => pathname === v.path || pathname.startsWith(`${v.path}/`));
  return hit?.id ?? 'position';
}
